export default __webpack_public_path__ + "media/images/visa-mastercard-d35c3355982b5e3eebf2b3f751c149d0.png";